/* global history */

import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './Styles/profile-modal-window.css'
import { Profile, SubscriptionPlan, Logout } from './Icons'
import { useAuth } from '../Context/Auth'

const ProfileModalWindow = ({ setAvatarClicked }) => {
  const { logout } = useAuth()
  const [error, setError] = useState('')
  const { currentUser } = useAuth()

  async function handleLogout () {
    setError('')
    try {
      await logout()
      history.push('/Login')
    } catch {
      setError('Failed to log out')
      const errorCode = error.code
      const errorMessage = error.message
      console.log(errorCode + ' ' + errorMessage)
    }
  }

  return (
    <div className='modal' onClick={e => e.stopPropagation()}>
      <div className='user-menu-item name-organisation'>
        <p className='p-name'>{currentUser.displayName}</p>
        <p className='p-org'>Test organization</p>
      </div>

      <Link
        to={{ pathname: '/settings', active: 'profile' }}
        onClick={() => setAvatarClicked(false)}
      >
        <div className='user-menu-item profile'>
          <button className='modal-btn top-border'>
            <Profile /> <span style={{ marginLeft: '10px' }}> Profile </span>
          </button>
        </div>
      </Link>

      <Link
        to={{ pathname: '/settings', active: 'subscription-plan' }}
        onClick={() => setAvatarClicked(false)}
      >
        <div className='user-menu-item subscription-plan'>
          <button className='modal-btn bottom-border'>
            <SubscriptionPlan /> <span style={{ marginLeft: '10px' }}> Subscription plan </span>
          </button>
        </div>
      </Link>

      <Link
        to='/'
        onClick={() => setAvatarClicked(false)}
      >
        <div className='user-menu-item logout'>
          <button
            className='modal-btn' style={{ paddingLeft: '18px' }} onClick={handleLogout}>
            <Logout /> <span style={{ marginLeft: '10px' }}> Log out </span>
          </button>
        </div>
      </Link>

    </div>
  )
}

export default ProfileModalWindow
